import { ActionTree, Module, MutationTree } from 'vuex'
import { RootState } from '@/interfaces/store/root'
import * as bannersService from '@/services/line-web-loyalty-bff/v1/banners'
import liff from '@line/liff'
import { BannersItemList, BannerType, MarketingBanner } from '@/interfaces/banners-list'
import { Actions, Mutations, BannersListPayload, BannersListState } from '@/interfaces/store/bannersList'
import { getOrderObjectArrayByNumber } from '@/helpers/orderArray'

export const state: BannersListState = {
  banners: {
    isLoading: true,
    items: []
  }
}

export const actions: ActionTree<BannersListState, RootState> & Actions = {
  async fetchBannersList({ commit }, payload: BannersListPayload) {
    commit('updateBannersListIsLoading', true)
    commit('updateBannersList', [])

    try {
      const { token } = payload
      if (token) {
        const result = await bannersService.getBannersList(token)
        const statusCode = result.httpStatusCode
        if (statusCode === 200) {
          const response: BannersItemList[] = result.json.data.length > 0 
          ? result.json.data.map((item: BannersItemList) => ({
              ...item,
              marketingBannerFragment: Array.isArray(item.marketingBannerFragment) && item.marketingBannerFragment.length > 0
                ? (item.marketingBannerFragment as MarketingBanner[]).map(fragment => ({
                    ...fragment,
                    bannerImage: Array.isArray(fragment.bannerImage) && fragment.bannerImage.length === 0
                      ? undefined
                      : fragment.bannerImage as BannerType | undefined,
                    externalBannerLink: fragment.externalBannerLink ?? undefined,
                    deepLinkForApp: fragment.deepLinkForApp ?? undefined,
                    shareLink: fragment.shareLink ?? undefined
                  }))
                : []
            }))
          : []

          commit('updateBannersList', getOrderObjectArrayByNumber(response, 'order'))
        } else if (statusCode === 401) {
          console.warn('Unauthorized, redirecting to login')
          liff.logout()
          liff.login()
        } else {
          throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
        }
      } else {
        throw new Error('fetchBannersList token is missing')
      }
    } catch (error) {
      console.log(error)
    } finally {
      commit('updateBannersListIsLoading', false)
    }
  }
}

export const mutations: MutationTree<BannersListState> & Mutations = {
  updateBannersListIsLoading(state: BannersListState, loading: boolean) {
    state.banners.isLoading = loading
  },
  updateBannersList(state: BannersListState, bannersList: BannersItemList[]) {
    state.banners.items = bannersList
  }
}

export const store: Module<BannersListState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
}
